import { AddressesMutations } from './partials/addresses'
import { EmailsMutations } from './partials/emails'
import { PartyEditMutations } from './partials/party-edit'
import { PartyMergeMutations } from './partials/party-merge'
import { PartySurveysPageMutations } from './partials/party-surveys-page'
import { PartyTagMutations } from './partials/party-tag'
import { PhonesMutations } from './partials/phones'
import { ResidenceHistoriesMutations } from './partials/residence-histories'

export const PartyMutations = {
  ...AddressesMutations,
  ...EmailsMutations,
  ...PartyEditMutations,
  ...PartyMergeMutations,
  ...PartyTagMutations,
  ...PhonesMutations,
  ...ResidenceHistoriesMutations,
  ...PartySurveysPageMutations,
  setCurrentParty: (state, value) => { state.currentParty = value },
  setPartySaveTriggered: (state, payload) => {
    state.saveAddressesTriggered = payload
    state.saveEmailsTriggered = payload
    state.savePhonesTriggered = payload
    state.saveResidenceHistoriesTriggered = payload
  },
  setParties: (state, payload) => { state.parties = payload },
  setSearchLoading: (state, value) => {
    state.isSearching = value
  },
}
